import { ProductPartDto } from "./ProductPartDto";
import {CustomFieldValueDto} from './CustomFieldValueDto';

export class ProductDto {
	constructor(public Id: number, public EntityId: number, public Parts: ProductPartDto[], public CustomFieldValues: CustomFieldValueDto[]) { }
}